export const STANDALONE_SCALE = 1.2

export const scaleFontSize = (baseSize: number) => `${Number(baseSize * STANDALONE_SCALE).toFixed(1)}px`
